module.exports = __webpack_public_path__ + "static/img/pic_dkjj_gjdkjcss_title.821f7468.png";